<template>
  <el-container>
    <el-aside width="200px">
      <MpSiderNav />
    </el-aside>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import MpSiderNav from "@/components/MpSiderNav.vue";
export default {
  name: "app",
  components: {
    MpSiderNav
    // HelloWorld
  }
};
</script>

<style>
.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  /* line-height: 200px; */
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  /* line-height: 160px; */
}
</style>
